<template>
  <transition name="fade">
    <new-message-mobile v-if="isUnReadMessage" />
  </transition>
  <template v-if="type != 'empty'">
    <header>
      <div class="noticeWrap">
        <div class="notice"><em>{{$t('front.common.notices')}}</em><span>{{$t('front.header.msg')}}</span></div>
        <div class="langbtn" @click="openLang()">
          <button class="langdropbtn" >
            <template v-if="$i18n.locale === 'ko'">
              <img src="@/assets_mobile/img/korea.png" /><span class="langsp">KO</span>
            </template>
            <template v-if="$i18n.locale === 'en'">
              <img src="@/assets/img/eng.png" /><span class="langsp">EN</span>
            </template>
            <template v-if="$i18n.locale === 'vn'">
              <img src="@/assets/img/vn.svg" /><span class="langsp">VN</span>
            </template>
            <img class="langbtnb" src="@/assets_mobile/img/langbtn.png" />
          </button>
          <div class="langdropdown" v-if="isOpenLang">
            <a href="#" :class="{'on': $i18n.locale === 'ko'}" @click="changeLocale('ko')">KR</a>
            <a href="#" :class="{'on': $i18n.locale === 'en'}" @click="changeLocale('en')">EN</a>
            <a href="#" :class="{'on': $i18n.locale === 'vn'}" @click="changeLocale('vn')">VN</a>
          </div>
        </div>
      </div>

      <div class="header">
        <div class="tophead">
          <!--
          <div v-if="!userData">
             <a class="mjoinbtn" @click="goPageByName('mobileJoin')">JOIN</a>
             <a class="mloginbtn ml10" @click="goPageByName('mobileLogin')">LOGIN</a>
           </div>
          -->
          <button v-if="!userData" class="m-head-icon user" type="button" @click="goPageByName('mobileLogin')">
            <span></span>
          </button>
          <button v-if="userData" class="m-head-icon user" type="button" @click="onClickMobileUser">
            <span></span>
          </button>
          <div class="logo">
            <a href="/" aria-label="데이지 홈으로 이동 및 새로고침">
              <img src="@/assets/img/daisy-logo.png" alt="데이지" />
            </a>
          </div>
          <!-- 오른쪽 햄버거 버튼 -->
          <button
            class="m-head-icon menu"
            type="button"
            :class="{ on: isMobileMenuOpen }"
            @click="toggleMobileMenu"
          >
            <span>MENU</span>
          </button>
        </div>
        <transition name="fade">
          <div
            class="m-menu-dim"
            v-if="isMobileMenuOpen"
            @click.self="closeMobileMenu"
          >
            <div class="m-menu-panel">
              <div class="m-menu-head">
                <button class="m-head-icon user" type="button" @click="onClickMobileUser">
                  <span>USER</span>
                </button>

                <div class="logo">
                  <a href="/" aria-label="데이지 홈으로 이동 및 새로고침">
                    <img src="@/assets/img/daisy-logo.png" alt="데이지" />
                  </a>
                </div>

                <button class="m-head-icon close" type="button" @click="closeMobileMenu">
                  <span>CLOSE</span>
                </button>
              </div>

              <ul class="m-menu-list">
                <li @click="goPageByName('mobileMain')">
                  <em>🏆</em>
                  <span>게임</span>
                </li>
                <li @click="goPageByName('charge')">
                  <em>💵</em>
                  <span>충전</span>
                </li>
                <li @click="goPageByName('exchange')">
                  <em>💧</em>
                  <span>환전</span>
                </li>
                <li @click="goPageByName('betList')">
                  <em>⏱️</em>
                  <span>베팅 기록</span>
                </li>
                <li @click="goPageByName('qnaList')">
                  <em>🔮</em>
                  <span>1:1문의하기</span>
                </li>
                <li @click="goPageByName('noticeList')">
                  <em>❤️</em>
                  <span>공지사항</span>
                </li>
              </ul>
              <div class="m-menu-bottom" v-if="userData">
                <button type="button" class="m-menu-logout" @click="onLogOut">
                  <em>↪</em>
                  <span>로그아웃</span>
                </button>
              </div>
            </div>
          </div>
        </transition>
        <!-- <ul class="fxhead">
         <li class="atten" :class="{'on': $route.meta.gnbMenu === 'charge'}"><a @click="goPageByName('charge')"><em></em><span>{{$t('front.common.deposit')}}</span></a></li>
         <li class="notices" :class="{'on': $route.meta.gnbMenu === 'exchange'}"><a @click="goPageByName('exchange')"><em></em><span>{{$t('front.common.withdrawal')}}</span></a></li>
         <li class="home" :class="{'on': $route.meta.gnbMenu === 'betList'}"><a @click="goPageByName('betList')"><em></em><span>{{$t('front.mypage.betList')}}</span></a></li>
         <li class="ques" :class="{'on': $route.meta.gnbMenu === 'cs'}"><a @click="goPageByName('qnaList')"><em></em><span>{{$t('front.common.cscenter')}}</span></a></li>
         <li class="my" :class="{'on': $route.meta.gnbMenu === 'myinfo'}"><a @click="goPageByName('myinfo')"><em></em><span>{{$t('front.common.mypage')}}</span></a></li>
       </ul> -->
      </div>

    </header>
  </template>
</template>

<script>

import { mapState } from 'vuex'
import NewMessageMobile from '@/components/member/MessageMobile.vue'

export default {
  name: 'Header',
  components: { NewMessageMobile },
  props: [
    'type'
  ],
  data () {
    return {
      isOpenLang: false,
      isMobileMenuOpen: false
    }
  },
  computed: {
    ...mapState([
      'userData',
      'unReadMessageCount'
    ]),
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    }
  },
  unmounted () {
    document.body.style.overflow = ''
  },
  watch: {
    $route () {
      this.closeMobileMenu()
    }
  },
  methods: {
    onClickMobileUser () {
      this.closeMobileMenu()

      if (this.userData) {
        this.goPageByName('myinfo')
      } else {
        this.onClickLogin()
      }
    },

    toggleMobileMenu () {
      this.isMobileMenuOpen = !this.isMobileMenuOpen

      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },

    closeMobileMenu () {
      this.isMobileMenuOpen = false
      document.body.style.overflow = ''
    },
    openLang () {
      this.isOpenLang = !this.isOpenLang
    },
    onLogOut () {
      this.$root.signOut()
      this.$router.push({ name: 'main' })
      // location.reload()
    }
  }
}
</script>

<style scoped src="@/styles_mobile/header.css"></style>
<style scoped src="@/styles_mobile/common.css"></style>
<style scoped src="@/styles_mobile/swiper.min.css"></style>
<style scoped src="@/styles_mobile/subcommon.css"></style>
